import { render, staticRenderFns } from "./assign-to-user.vue?vue&type=template&id=8b1ed0f8"
import script from "./assign-to-user.vue?vue&type=script&lang=js"
export * from "./assign-to-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports